<template>
  <div class="home-container">
    <div id="home-map" class="home-map"></div>
    <div class="home-content">
      <!-- 左边图表 -->
      <div class="home-content-left">
        <div class="home-content-left-top">
          <box :width="399" :height="307">
            <div class="chart-title-box">
              <div class="title-box">
                <img src="../../assets/yibiao.png" alt="" />
                <div class="title">路线行驶里程数</div>
              </div>
              <div class="date-box">
                <div>
                  <a-select
                    v-model="mileChartYear"
                    dropdown-class-name="milesDropdown"
                    style="width: 120px"
                    @change="setMileChart(1)"
                  >
                    <img
                      slot="suffixIcon"
                      src="../../assets/bottom-arrow.png"
                      alt=""
                    />
                    <a-select-option value="2020">
                      2020年
                    </a-select-option>
                    <a-select-option value="2021">
                      2021年
                    </a-select-option>
                    <a-select-option value="2022">
                      2022年
                    </a-select-option>
                    <a-select-option value="2023">
                      2023年
                    </a-select-option>
                    <a-select-option value="2024">
                      2024年
                    </a-select-option>
                    <a-select-option value="2025">
                      2025年
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>
            <img class="chart-line" src="../../assets/chart-line.png" alt="" />
            <div ref="mileChart" class="mile-chart-box" id="mileChart"></div>
          </box>
        </div>
        <div class="home-content-left-middle">
          <box :width="399" :height="217">
            <div class="chart-title-box">
              <div class="title-box">
                <img src="../../assets/yibiao.png" alt="" />
                <div class="title">路线类型</div>
              </div>
              <div class="date-box"></div>
            </div>
            <img class="chart-line" src="../../assets/chart-line.png" alt="" />
            <div class="route-type-box">
              <div class="route-type-item">
                <div class="route-type-circle blue-circle">
                  {{ statisticsData.shiftLine }}
                </div>
                <div class="route-type-per-box">
                  <div>
                    {{
                      statisticsData.shiftLine == 0
                        ? "0%"
                        : (
                            (statisticsData.shiftLine /
                              (statisticsData.shiftLine +
                                statisticsData.charter +
                                statisticsData.passengerTransport)) *
                            100
                          ).toFixed(0) + "%"
                    }}
                  </div>
                  <img src="../../assets/route-type.png" alt="" />
                </div>
                <div class="route-type-title">班线线路</div>
              </div>
              <div class="route-type-item">
                <div class="route-type-circle green-circle">
                  {{ statisticsData.charter }}
                </div>
                <div class="route-type-per-box">
                  <div>
                    {{
                      statisticsData.charter == 0
                        ? "0%"
                        : (
                            (statisticsData.charter /
                              (statisticsData.shiftLine +
                                statisticsData.charter +
                                statisticsData.passengerTransport)) *
                            100
                          ).toFixed(0) + "%"
                    }}
                  </div>
                  <img src="../../assets/route-type.png" alt="" />
                </div>
                <div class="route-type-title" style="color: #27d6ad;">
                  包车线路
                </div>
              </div>
              <div class="route-type-item">
                <div class="route-type-circle yellow-circle">
                  {{ statisticsData.passengerTransport }}
                </div>
                <div class="route-type-per-box">
                  <div>
                    {{
                      statisticsData.passengerTransport == 0
                        ? "0%"
                        : (
                            (statisticsData.passengerTransport /
                              (statisticsData.shiftLine +
                                statisticsData.charter +
                                statisticsData.passengerTransport)) *
                            100
                          ).toFixed(0) + "%"
                    }}
                  </div>
                  <img src="../../assets/route-type.png" alt="" />
                </div>
                <div class="route-type-title" style="color: #f2c448;">
                  客运线路
                </div>
              </div>
            </div>
          </box>
        </div>
        <div class="home-content-left-bottom">
          <box :width="399" :height="378">
            <div class="chart-title-box">
              <div class="title-box">
                <img class="service" src="../../assets/service.png" alt="" />
                <div class="title">路线行驶次数</div>
              </div>
              <div class="date-box">
                <div>
                  <a-select
                    v-model="countChartYear"
                    dropdown-class-name="milesDropdown"
                    style="width: 120px"
                    @change="setRouteChart(2)"
                  >
                    <img
                      slot="suffixIcon"
                      src="../../assets/bottom-arrow.png"
                      alt=""
                    />
                    <a-select-option value="2020">
                      2020年
                    </a-select-option>
                    <a-select-option value="2021">
                      2021年
                    </a-select-option>
                    <a-select-option value="2022">
                      2022年
                    </a-select-option>
                    <a-select-option value="2023">
                      2023年
                    </a-select-option>
                    <a-select-option value="2024">
                      2024年
                    </a-select-option>
                    <a-select-option value="2025">
                      2025年
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>
            <img class="chart-line" src="../../assets/chart-line.png" alt="" />
            <div ref="countChart" class="count-chart-box" id="countChart"></div>
          </box>
        </div>
      </div>

      <!-- 中间部分 -->
      <div class="home-content-middle">
        <div class="middle-miles-box">
          <img src="../../assets/manbiao.png" alt="" />
          <div class="middle-miles-box-text">
            <div class="middle-miles-large-text">
              <div class="middle-miles-large-title">总公里数</div>
              <div class="middle-miles-large-num">
                {{ statisticsData.MileageAll || 0 }}
              </div>
            </div>
            <div class="unit">万公里</div>
          </div>
        </div>

        <div class="middle-cars-box">
          <div class="middle-cars-item">
            <div class="middle-cars-item-title-box">
              <img src="../../assets/map.png" alt="" />
              <div class="middle-cars-item-title">线路总数</div>
            </div>
            <div class="middle-cars-item-num-box">
              <div class="number">{{ statisticsData.routeALL || 0 }}</div>
              <div class="unit">个</div>
            </div>
          </div>

          <div class="cars-line"></div>

          <div class="middle-cars-item">
            <div class="middle-cars-item-title-box">
              <img src="../../assets/siji.png" alt="" />
              <div class="middle-cars-item-title">司机总数</div>
            </div>
            <div class="middle-cars-item-num-box">
              <div class="number">{{ statisticsData.driverNum || 0 }}</div>
              <div class="unit">个</div>
            </div>
          </div>

          <div class="cars-line"></div>

          <div class="middle-cars-item">
            <div class="middle-cars-item-title-box">
              <img
                class="car-bg"
                src="../../assets/zaixiancheliang.png"
                alt=""
              />
              <div class="middle-cars-item-title">在线车辆</div>
            </div>
            <div class="middle-cars-item-num-box">
              <div class="number">{{ statisticsData.carOnline || 0 }}</div>
              <div class="unit">个</div>
            </div>
          </div>

          <div class="cars-line"></div>

          <div class="middle-cars-item">
            <div class="middle-cars-item-title-box">
              <img
                class="car-bg"
                src="../../assets/lixiancheliang.png"
                alt=""
              />
              <div class="middle-cars-item-title">离线车辆</div>
            </div>
            <div class="middle-cars-item-num-box">
              <div class="number">{{ statisticsData.cartNum || 0 }}</div>
              <div class="unit">个</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右边部分 -->
      <div class="home-content-right">
        <div class="home-content-right-top">
          <box :width="399" :height="495">
            <div class="chart-title-box">
              <div class="title-box">
                <img class="driver" src="../../assets/driver.png" alt="" />
                <div class="title">司机数据</div>
              </div>
              <div class="date-box"></div>
            </div>
            <img class="chart-line" src="../../assets/chart-line.png" alt="" />

            <div class="search-box">
              <a-input-search
                v-model="driverName"
                placeholder="请输入司机姓名"
                enter-button
                @search="getDriverData()"
              />
            </div>
            <div class="table-box">
              <a-table
                :rowKey="(record, index) => { return index }"
                :columns="driverColumns"
                :pagination="false"
                :data-source="driverData"
                :scroll="{ y: '15.8vw' }"
              >
              </a-table>
            </div>
          </box>
        </div>
        <div class="home-content-right-bottom">
          <box :width="399" :height="415">
            <div class="chart-title-box">
              <div class="title-box">
                <img class="car" src="../../assets/car.png" alt="" />
                <div class="title">车辆数据</div>
              </div>
              <div class="date-box"></div>
            </div>
            <img class="chart-line" src="../../assets/chart-line.png" alt="" />

            <div class="search-box">
              <a-input-search
                v-model="numberPlate"
                placeholder="请输入车牌号"
                enter-button
                @search="getCarData()"
              />
            </div>
            <div class="table-box">
              <a-table
                :rowKey="(record, index) => { return index }"
                :columns="carColumns"
                :pagination="false"
                :data-source="carData"
                :scroll="{ y: '11vw' }"
              >
              </a-table>
            </div>
          </box>
        </div>
      </div>
    </div>

    <div
      v-show="showModal"
      ref="infoData"
      class="info-modal"
      :style="{
        background: currentDCarData.isOnline
          ? currentDCarData.routeState == '2'
            ? `url(${require('../../assets/green-modal.png')})`
            : currentDCarData.routeState == '1'
            ? `url(${require('../../assets/blue-modal.png')})`
            : `url(${require('../../assets/yellow-modal.png')})`
          : `url(${require('../../assets/gray-modal.png')})`
      }"
    >
      <div class="title-box">
        <div class="title-left-box">
          <img
            :src="
              currentDCarData.isOnline
                ? currentDCarData.routeState == '2'
                  ? `${require('../../assets/green-info.png')}`
                  : currentDCarData.routeState == '1'
                  ? `${require('../../assets/blue-info.png')}`
                  : `${require('../../assets/yellow-info.png')}`
                : `${require('../../assets/gray-info.png')}`
            "
            alt=""
          />
          <div class="title" :style="{ color: computedColor() + '1)' }">
            车辆信息
          </div>
          <div
            v-if="currentDCarData.isOnline"
            class="type-box"
            :style="{
              color: computedColor() + '1)',
              backgroundColor: computedColor() + '0.25)'
            }"
          >
            {{ currentDCarData.type }}
          </div>
        </div>
        <div class="state-box" :style="{ color: computedColor() + '1)' }">
          <div
            class="state-dot"
            :style="{
              backgroundColor: computedColor() + '1)'
            }"
          ></div>
          {{ currentDCarData.isOnline ? "在线" : "离线" }}
        </div>
      </div>

      <div class="company">{{ currentDCarData.companyName }}</div>
      <div class="info-box">
        <div class="info-left">
          <div class="info-left-item">
            <div class="info-left-item-desc">车辆编号：</div>
            <div :style="{ color: computedColor() + '1)' }">
              {{ currentDCarData.code }}
            </div>
          </div>
          <div class="info-left-item">
            <div class="info-left-item-desc">司机：</div>
            <div :style="{ color: computedColor() + '1)' }">
              {{ currentDCarData.driverName }}
            </div>
          </div>
          <div class="info-left-item">
            <div class="info-left-item-desc">车辆类型：</div>
            <div :style="{ color: computedColor() + '1)' }">
              {{ currentDCarData.carType }}
            </div>
          </div>
        </div>
        <div class="info-left">
          <div class="info-left-item">
            <div class="info-left-item-desc">车牌号：</div>
            <div :style="{ color: computedColor() + '1)' }">
              {{ currentDCarData.numberPlate }}
            </div>
          </div>
          <div class="info-left-item">
            <div class="info-left-item-desc">公里数：</div>
            <div :style="{ color: computedColor() + '1)' }">
              {{ currentDCarData.mileageStatistics }}
            </div>
          </div>
          <div class="info-left-item">
            <div class="info-left-item-desc">座位数：</div>
            <div :style="{ color: computedColor() + '1)' }">
              {{ currentDCarData.seatNum }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="detail-button"
        :style="{
          backgroundColor: computedColor() + '0.8)'
        }"
        @click="jumpDetail"
      >
        查看详情
      </div>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
import deepClone from "../../utils/deepClone";
import Box from "@/components/Box";
import { mileChartOptions, countOptions } from "./chartsConfig";
export default {
  name: "Home",
  components: { Box },
  data() {
    return {
      showModal: false,
      map: null,
      mileChartInstance: null,
      countChartInstance: null,
      currentDCarData: {
        type: "包车",
        modalBg: require("../../assets/gray-modal.png"),
        icon: require("../../assets/green-car.png"), //点标记图片路径
        state: "online",
        company: "安徽易为茂电动车应用技术有限公司",
        carNum: "c00000020",
        license: "皖A-A3730",
        driver: "张星星",
        miles: "8100km",
        carType: "豪华纯电动大巴",
        seats: "47座",
        position: [117.279358, 31.868547],
        offset: new AMap.Pixel(-12, -30)
      },
      markerData: [
        {
          type: "包车",
          icon: require("../../assets/green-car.png"), //点标记图片路径
          state: "online",
          company: "安徽易为茂电动车应用技术有限公司",
          carNum: "c00000020",
          license: "皖A-A3730",
          driver: "张星星",
          miles: "8100km",
          carType: "豪华纯电动大巴",
          seats: "47座",
          position: [117.279358, 31.868547],
          offset: new AMap.Pixel(-12, -30)
        },
        {
          type: "班车",
          icon: require("../../assets/blue-car.png"), //点标记图片路径
          state: "online",
          company: "安徽易为茂电动车应用技术有限公司",
          carNum: "c00000020",
          license: "皖A-A3730",
          driver: "张星星",
          miles: "8100km",
          carType: "豪华纯电动大巴",
          seats: "47座",
          position: [117.287941, 31.880063],
          offset: new AMap.Pixel(-12, -30)
        },
        {
          type: "班车",
          icon: require("../../assets/gray-car.png"), //点标记图片路径
          state: "offline",
          company: "安徽易为茂电动车应用技术有限公司",
          carNum: "c00000020",
          license: "皖A-A3730",
          driver: "张星星",
          miles: "8100km",
          carType: "豪华纯电动大巴",
          seats: "47座",
          position: [117.255154, 31.843614],
          offset: new AMap.Pixel(-12, -30)
        },
        {
          type: "客运",
          icon: require("../../assets/yellow-car.png"), //点标记图片路径
          state: "online",
          company: "安徽易为茂电动车应用技术有限公司",
          carNum: "c00000020",
          license: "皖A-A3730",
          driver: "张星星",
          miles: "8100km",
          carType: "豪华纯电动大巴",
          seats: "47座",
          position: [117.285366, 31.847114],
          offset: new AMap.Pixel(-12, -30)
        }
      ],
      driverColumns: [
        {
          title: "排名",
          dataIndex: "sort",
          key: "sort"
        },
        {
          title: "司机",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "行驶次数",
          dataIndex: "numAll",
          key: "numAll"
        },
        {
          title: "行驶公里数",
          dataIndex: "mileageAll",
          key: "mileageAll"
        }
      ],
      driverData: [],
      carColumns: [
        {
          title: "车辆",
          dataIndex: "numberPlate",
          key: "numberPlate"
        },
        {
          title: "行驶次数",
          dataIndex: "numAll",
          key: "numAll"
        },
        {
          title: "行驶公里数",
          dataIndex: "mileageAll",
          key: "mileageAll"
        }
      ],
      carData: [],
      statisticsData: { shiftLine: 0, passengerTransport: 0, charter: 0 },
      mileChartYear: new Date().getFullYear(),
      countChartYear: new Date().getFullYear(),
      query: {},
      driverName: "",
      numberPlate: ""
    };
  },

  mounted() {
    console.log('222')
    this.map = this.initMap();
    this.map.clearMap();
    this.query = this.$route.query;

    this.initPageData();
    this.initSocket(this.query);
    this.setMileChart(1);
    this.setRouteChart(2);
    this.$store.dispatch("setButtonStatus", 1);
    this.getDriverData();
    this.getCarData();
  },
  methods: {
    getDriverData() {
      this.getCarByYear(1).then(res => {
        this.driverData = res.driverVOList;
      });
    },
    getCarData() {
      this.getCarByYear(2).then(res => {
        this.carData = res.carVoList;
      });
    },
    setMileChart(state) {
      this.getDateByYear(state).then(res => {
        let shiftLineData = []; //班线
        let charterData = []; //包车
        let passengerTransportData = []; //客运
        for (let i = 0; i < res.routeList.length; i++) {
          shiftLineData.push(res.routeList[i].routeNum1);
          charterData.push(res.routeList[i].routeNum2);
          passengerTransportData.push(res.routeList[i].routeNum3);
        }
        mileChartOptions.series[0].data = shiftLineData;
        mileChartOptions.series[1].data = charterData;
        mileChartOptions.series[2].data = passengerTransportData;
        this.mileChartInstance = this.$echarts.initCharts(
          this.mileChartInstance,
          this.$refs["mileChart"],
          mileChartOptions
        );
      });
    },
    setRouteChart(state) {
      this.getDateByYear(state).then(res => {
        let shiftLineData = []; //班线
        let charterData = []; //包车
        let passengerTransportData = []; //客运
        for (let i = 0; i < res.MileageList.length; i++) {
          shiftLineData.push(res.MileageList[i].mileage1);
          charterData.push(res.MileageList[i].mileage2);
          passengerTransportData.push(res.MileageList[i].mileage3);
        }
        countOptions.series[0].data = shiftLineData;
        countOptions.series[1].data = charterData;
        countOptions.series[2].data = passengerTransportData;
        this.countChartInstance = this.$echarts.initCharts(
          this.countChartInstance,
          this.$refs["countChart"],
          countOptions
        );
      });
    },
    //根据年份获取路线或公里数
    getDateByYear(state) {
      let params = {
        state: state,
        ownerId: this.$Cookies.get("ownerId")
          ? this.$Cookies.get("ownerId")
          : -1
      };
      if (state == 1) {
        params.routeYear = this.mileChartYear;
      } else {
        params.kilometreYear = this.countChartYear;
      }
      return this.$api.home
        .getDateByYear({ ...params })
        .then(result => {
          if (result.code == 1) {
            return result.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //根据年份获取车辆/司机首页数据
    getCarByYear(state) {
      let data = {
        state: state,
        ownerId: this.$Cookies.get("ownerId")
          ? this.$Cookies.get("ownerId")
          : -1
      };
      if (state == 1) {
        data.driverName = this.driverName;
      } else {
        data.numberPlate = this.numberPlate;
      }
      return this.$api.home
        .getCarByYear({ ...data })
        .then(result => {
          if (result.code == 1) {
            return result.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 初始化socket
    initSocket(query) {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // let tokenObj = JSON.parse(this.$Cookies.get("evmall_token"));
        let tokenObj = this.$Cookies.get("evmall_token") ? JSON.parse(this.$Cookies.get("evmall_token")):{}
        // 实例化socket
        this.socket = new WebSocket(
          `${$SERVER.socketUrl}/${new Date().getTime()}/-2/${
            query.token ? query.token : tokenObj.token
          }/${query.ownerId ? query.ownerId : -1}`
        );
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
      }
    },
    open: function() {
      console.log("socket连接成功");
    },
    error: function() {
      console.log("连接错误");
    },
    getMessage: function(msg) {
      let data = JSON.parse(msg.data);
      this.markerData = data.resObj.bCarVOS;
      this.addMarker();
    },
    send: function() {
      this.socket.send(params);
    },
    close: function() {
      console.log("socket已经关闭");
    },

    //加载初始数据
    initPageData() {
      this.$api.home
        .getStatistics({
          ownerId: this.$Cookies.get("ownerId")
            ? this.$Cookies.get("ownerId")
            : -1
        })
        .then(result => {
          console.log(result, "result==");
          if (result.code == 1) {
            this.statisticsData = result.data;
          } else if (result.code == 0) {
            this.$router.push("/login");
          }
        })
        .catch(err => {
          console.log(err, "err");
          console.log(err);
        });
    },
    // 选择字体颜色
    computedColor() {
      if (this.currentDCarData.isOnline) {
        if (this.currentDCarData.routeState == "2") {
          return "rgba(40, 218, 172, ";
        }
        if (this.currentDCarData.routeState == "1") {
          return "rgba(64, 230, 255, ";
        }
        if (this.currentDCarData.routeState == "3") {
          return "rgba(240, 191, 61, ";
        }
      } else {
        return "rgba(174, 214, 237, ";
      }
    },

    initMap() {
      let map = new AMap.Map("home-map", {
        resizeEnable: true, //自适应大小
        zoom: 13, //初始视窗
        scrollWheel: false,
        viewMode: "3D",
        mapStyle: "amap://styles/48973c04a03806fd9a451891d922af47" //设置地图的显示样式
      });

      //  显示缩放加减号
      AMap.plugin(["AMap.ControlBar"], function() {
        // 添加 3D 罗盘控制
        map.addControl(new AMap.ControlBar());
      });
      return map;
    },

    //2.添加点标记
    addMarker() {
      const self = this;
      let arr = [];
      this.markerData.forEach(item => {
        let marker = new AMap.Marker({
          icon: item.isOnline
            ? item.routeState == 1
              ? require("../../assets/blue-car.png")
              : item.routeState == 2
              ? require("../../assets/green-car.png")
              : require("../../assets/yellow-car.png")
            : require("../../assets/gray-car.png"), //点标记图片路径
          position: [item.latAndLon.lon, item.latAndLon.lat] //位置
        });
        arr.push(
          Object.assign(item, {
            mapId: marker._amap_id
          })
        );
        marker.setMap(self.map);
        AMap.event.addListener(marker, "mouseover", e => {
          self.markerClick(arr, marker);
        });
        AMap.event.addListener(marker, "mouseout", e => {
          this.closeInfoWindow(e);
        });
      });
      this.map.setFitView();
    },

    //3.点击标记 获取所点击标记的信息以及窗体要展示的数据，创建信息窗体
    markerClick(arr, marker) {
      let arrNew = arr.filter(x => x.mapId == marker._amap_id);
      let data = arrNew && arrNew[0];
      this.$api.home
        .getCarDetails({ carId: data.id })
        .then(result => {
          this.currentDCarData = result.data.car;
        })
        .catch(err => {
          console.log(err);
        });
      let infoWindow = this.createInfoWindow();
      this.openInfoWindow(infoWindow, marker);
    },

    jumpDetail() {
      this.$router.push({
        path: "/car-detail",
        query: {
          id: this.currentDCarData.id
        }
      });
    },
    //4.构建自定义窗体
    createInfoWindow() {
      let infoWindowData = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: this.$refs.infoData,
        // content: this.getContent(),
        offset: new AMap.Pixel(16, -30)
      });
      return infoWindowData;
    },

    //5.打开窗体
    openInfoWindow(infoWindow, marker) {
      this.showModal = true;
      infoWindow.open(this.map, marker.getPosition());
    },
    //6.关闭窗体
    closeInfoWindow() {
      this.showModal = false;
      this.map.clearInfoWindow();
    },
    // setCharts() {
    //   this.mileChartInstance = this.$echarts.initCharts(
    //     this.mileChartInstance,
    //     this.$refs["mileChart"],
    //     this.setOptions(mileChartOptions, this.utilizeEchartData)
    //   );
    //
    //   this.countChartInstance = this.$echarts.initCharts(
    //     this.countChartInstance,
    //     this.$refs["countChart"],
    //     this.setOptions(countOptions, this.utilizeEchartData)
    //   );
    // },

    setOptions(option, seriesData) {
      option = deepClone(option);
      // option.series[0].data = seriesData;
      return option;
    }
  }
};
</script>
<style lang="less">
@import "./index.less";
</style>
